import React from "react";

import {
    Bike,
    Car,
    CreditCard,
    ShieldCheck,
    BadgeCheck
} from "lucide-react";

import "./VehicleInfo.css";

function VehicleInfo({ profile }) {

    const vehicle = [

        {
            icon: <Bike />,
            title: "Vehicle Type",
            value: profile?.vehicle?.type || "Bike"
        },

        {
            icon: <Car />,
            title: "Vehicle Number",
            value: profile?.vehicle?.number || "Not Added"
        },

        {
            icon: <CreditCard />,
            title: "Driving License",
            value: profile?.vehicle?.licenseNumber || "Not Added"
        },

        {
            icon: <ShieldCheck />,
            title: "Insurance Status",
            value:
                profile?.vehicle?.insuranceVerified
                    ? "Verified"
                    : "Pending Verification"
        }

    ];

    return (

        <div className="hf-vehicle-card">

            <div className="hf-vehicle-header">

                <div>

                    <h2>

                        Vehicle Information

                    </h2>

                    <p>

                        Registered vehicle details used for deliveries.

                    </p>

                </div>

                <div className="hf-vehicle-badge">

                    <BadgeCheck size={18} />

                    Active

                </div>

            </div>

            <div className="hf-vehicle-grid">

                {

                    vehicle.map((item,index)=>(

                        <div
                            key={index}
                            className="hf-vehicle-item"
                        >

                            <div className="hf-vehicle-icon">

                                {item.icon}

                            </div>

                            <div className="hf-vehicle-content">

                                <span>

                                    {item.title}

                                </span>

                                <h4>

                                    {item.value}

                                </h4>

                            </div>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default VehicleInfo;